export const getBodyData = async (request) => {
  const { data } = await request;

  return data;
};

